// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TerminiRouteImport } from './routes/termini'
import { Route as SearchRouteImport } from './routes/search'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as PremiumRouteImport } from './routes/premium'
import { Route as MappaRouteImport } from './routes/mappa'
import { Route as DiventaChefRouteImport } from './routes/diventa-chef'
import { Route as CookieRouteImport } from './routes/cookie'
import { Route as ContattiRouteImport } from './routes/contatti'
import { Route as ComeFunzionaRouteImport } from './routes/come-funziona'
import { Route as ChiSiamoRouteImport } from './routes/chi-siamo'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ChefSlugRouteImport } from './routes/chef.$slug'
import { Route as CheckoutReturnRouteImport } from './routes/checkout.return'
import { Route as AuthenticatedDashboardIndexRouteImport } from './routes/_authenticated/dashboard.index'
import { Route as AuthenticatedDashboardVerificaRouteImport } from './routes/_authenticated/dashboard.verifica'
import { Route as AuthenticatedDashboardRichiesteRouteImport } from './routes/_authenticated/dashboard.richieste'
import { Route as AuthenticatedDashboardProfiloRouteImport } from './routes/_authenticated/dashboard.profilo'
import { Route as AuthenticatedDashboardFotoRouteImport } from './routes/_authenticated/dashboard.foto'
import { Route as AuthenticatedDashboardAnnunciRouteImport } from './routes/_authenticated/dashboard.annunci'
import { Route as AuthenticatedDashboardAdminRouteImport } from './routes/_authenticated/dashboard.admin'
import { Route as AuthenticatedDashboardAccountRouteImport } from './routes/_authenticated/dashboard.account'
import { Route as AuthenticatedDashboardAdminEmailPreviewRouteImport } from './routes/_authenticated/dashboard.admin.email-preview'

const TerminiRoute = TerminiRouteImport.update({
            id: '/termini',path: '/termini',getParentRoute: () => rootRouteImport
          })
const SearchRoute = SearchRouteImport.update({
            id: '/search',path: '/search',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const PremiumRoute = PremiumRouteImport.update({
            id: '/premium',path: '/premium',getParentRoute: () => rootRouteImport
          })
const MappaRoute = MappaRouteImport.update({
            id: '/mappa',path: '/mappa',getParentRoute: () => rootRouteImport
          })
const DiventaChefRoute = DiventaChefRouteImport.update({
            id: '/diventa-chef',path: '/diventa-chef',getParentRoute: () => rootRouteImport
          })
const CookieRoute = CookieRouteImport.update({
            id: '/cookie',path: '/cookie',getParentRoute: () => rootRouteImport
          })
const ContattiRoute = ContattiRouteImport.update({
            id: '/contatti',path: '/contatti',getParentRoute: () => rootRouteImport
          })
const ComeFunzionaRoute = ComeFunzionaRouteImport.update({
            id: '/come-funziona',path: '/come-funziona',getParentRoute: () => rootRouteImport
          })
const ChiSiamoRoute = ChiSiamoRouteImport.update({
            id: '/chi-siamo',path: '/chi-siamo',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const ChefSlugRoute = ChefSlugRouteImport.update({
            id: '/chef/$slug',path: '/chef/$slug',getParentRoute: () => rootRouteImport
          })
const CheckoutReturnRoute = CheckoutReturnRouteImport.update({
            id: '/checkout/return',path: '/checkout/return',getParentRoute: () => rootRouteImport
          })
const AuthenticatedDashboardIndexRoute = AuthenticatedDashboardIndexRouteImport.update({
            id: '/dashboard/',path: '/dashboard/',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedDashboardVerificaRoute = AuthenticatedDashboardVerificaRouteImport.update({
            id: '/dashboard/verifica',path: '/dashboard/verifica',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedDashboardRichiesteRoute = AuthenticatedDashboardRichiesteRouteImport.update({
            id: '/dashboard/richieste',path: '/dashboard/richieste',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedDashboardProfiloRoute = AuthenticatedDashboardProfiloRouteImport.update({
            id: '/dashboard/profilo',path: '/dashboard/profilo',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedDashboardFotoRoute = AuthenticatedDashboardFotoRouteImport.update({
            id: '/dashboard/foto',path: '/dashboard/foto',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedDashboardAnnunciRoute = AuthenticatedDashboardAnnunciRouteImport.update({
            id: '/dashboard/annunci',path: '/dashboard/annunci',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedDashboardAdminRoute = AuthenticatedDashboardAdminRouteImport.update({
            id: '/dashboard/admin',path: '/dashboard/admin',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedDashboardAccountRoute = AuthenticatedDashboardAccountRouteImport.update({
            id: '/dashboard/account',path: '/dashboard/account',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedDashboardAdminEmailPreviewRoute = AuthenticatedDashboardAdminEmailPreviewRouteImport.update({
            id: '/email-preview',path: '/email-preview',getParentRoute: () => AuthenticatedDashboardAdminRoute
          })





const AuthenticatedDashboardAdminRouteChildren = {
  AuthenticatedDashboardAdminEmailPreviewRoute: AuthenticatedDashboardAdminEmailPreviewRoute
}

const AuthenticatedDashboardAdminRouteWithChildren = AuthenticatedDashboardAdminRoute._addFileChildren(AuthenticatedDashboardAdminRouteChildren)



const AuthenticatedRouteRouteChildren = {
  AuthenticatedDashboardAccountRoute: AuthenticatedDashboardAccountRoute,AuthenticatedDashboardAdminRoute: AuthenticatedDashboardAdminRouteWithChildren,AuthenticatedDashboardAnnunciRoute: AuthenticatedDashboardAnnunciRoute,AuthenticatedDashboardFotoRoute: AuthenticatedDashboardFotoRoute,AuthenticatedDashboardProfiloRoute: AuthenticatedDashboardProfiloRoute,AuthenticatedDashboardRichiesteRoute: AuthenticatedDashboardRichiesteRoute,AuthenticatedDashboardVerificaRoute: AuthenticatedDashboardVerificaRoute,AuthenticatedDashboardIndexRoute: AuthenticatedDashboardIndexRoute
}

const AuthenticatedRouteRouteWithChildren = AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,AuthRoute: AuthRoute,ChiSiamoRoute: ChiSiamoRoute,ComeFunzionaRoute: ComeFunzionaRoute,ContattiRoute: ContattiRoute,CookieRoute: CookieRoute,DiventaChefRoute: DiventaChefRoute,MappaRoute: MappaRoute,PremiumRoute: PremiumRoute,PrivacyRoute: PrivacyRoute,ResetPasswordRoute: ResetPasswordRoute,SearchRoute: SearchRoute,TerminiRoute: TerminiRoute,CheckoutReturnRoute: CheckoutReturnRoute,ChefSlugRoute: ChefSlugRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)